import { render, staticRenderFns } from "./moreOXTHDP.vue?vue&type=template&id=37f4d726&lang=pug&"
import script from "./moreOXTHDP.vue?vue&type=script&lang=js&"
export * from "./moreOXTHDP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports